module.exports = __webpack_public_path__ + "assets/b1.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b1.png
// module id = 569
// module chunks = 0